import { AGWASuiteApiClientBase, ApiResponse } from '../agwasuite-api';
import { ApiFactory } from '../agwasuite-api-factory';
import type {
  DataTableDataRequest,
  SecurityAuditLogResult,
} from '../agwa-api-model';

/**
 * API client for security audit log operations.
 * Provides endpoints for viewing and searching security audit logs.
 * Only accessible to AGWA staff with MemberAdmin rights.
 */
export class ApiSecurityAudit extends AGWASuiteApiClientBase {
  constructor(baseUrl?: string) {
    super(baseUrl);
  }

  /**
   * Search security audit logs with filtering, sorting, and pagination.
   * Requires MemberAdmin rights.
   */
  async searchAuditLogs(
    request: DataTableDataRequest
  ): Promise<ApiResponse<SecurityAuditLogResult>> {
    return this.postExecute<DataTableDataRequest, SecurityAuditLogResult>(
      '/api/securityaudit/search',
      request
    );
  }
}

/**
 * Get a SecurityAuditApi instance.
 * Creates a fresh instance each call to ensure current auth tokens.
 */
export function getSecurityAuditApi(): ApiSecurityAudit {
  return ApiFactory.authenticated(ApiSecurityAudit);
}
